import { usePrefetchQuery, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import axiosInstance from 'config/axiosConfig';
import { Lead } from 'types/Lead';

async function fetchLeads(page: number, status?: string) {
    try {
        const queryParams = `page=${page + 1}` + (status ? `&status=${status}` : '');
        const { data } = await axiosInstance(`/inquires?${queryParams}`);
        return data.data as { inquiries: Array<Lead>; total: number };
    } catch (error) {
        if (axios.isAxiosError(error)) throw new Error(error.response?.data.message);
        throw new Error(error as string);
    }
}

export const useLeads = (page: number, status?: string) => {
    return useQuery({
        queryKey: ['leads', page, status],
        queryFn: () => fetchLeads(page, status),
        staleTime: 60 * 5 * 1000,
    });
};

const allKeys = ['new', 'contacted', 'follow-up', 'active', 'inactive', 'qualified', 'closed'];

export const usePrefetchLeads = async () => {
    allKeys.forEach((key) => usePrefetchQuery({ queryKey: ['leads', 0, key], queryFn: () => fetchLeads(0, key) }));
};
